export default {
    msg: '',
    editar: {},
    lista: '',
    pesquisa: '',
    servico: '',
    geral: '',
    valorcalculo: '',
    comissionado: '',
    dias: '',
    basecalculo: '',
    folhar_id: '',
    quinzena: '',
    evento: '',
    bancos: '',
    rublicas: '',
    tomadores: '',
}
